import _ from 'lodash';
import {
  FETCH_DISTRICT_REQUEST,
  FETCH_DISTRICT_SUCCESS,
  FETCH_DISTRICT_FAILURE,
  FETCH_PG_LAYER_DATA_REQUEST,
  FETCH_PG_LAYER_DATA_SUCCESS,
  FETCH_PG_LAYER_DATA_FAILURE,
  FETCH_PGLAYERLIST_REQUEST,
  FETCH_PGLAYERLIST_SUCCESS,
  FETCH_PGLAYERLIST_FAILURE,
  DELETE_STYLE_REQUEST,
  DELETE_STYLE_SUCCESS,
  DELETE_STYLE_FAILURE,
  FETCH_UPDATE_STYLE_LIST_REQUEST,
  FETCH_UPDATE_STYLE_LIST_SUCCESS,
  FETCH_UPDATE_STYLE_LIST_FAILURE,
  FETCH_DISTRICT_COMPOSITIONS_REQUEST,
  FETCH_DISTRICT_COMPOSITIONS_SUCCESS,
  FETCH_DISTRICT_COMPOSITIONS_FAILURE,
  FETCH_DISTRICT_ROLES_REQUEST,
  FETCH_DISTRICT_ROLES_SUCCESS,
  FETCH_DISTRICT_ROLES_FAILURE,
  FETCH_DISTRICT_FEATURES_REQUEST,
  FETCH_DISTRICT_FEATURES_SUCCESS,
  FETCH_DISTRICT_FEATURES_FAILURE,
  FETCH_DISTRICT_LAYERS_REQUEST,
  FETCH_DISTRICT_LAYERS_SUCCESS,
  FETCH_DISTRICT_LAYERS_FAILURE,
  FETCH_DISTRICT_EXTERNALLAYERS_REQUEST,
  FETCH_DISTRICT_EXTERNALLAYERS_SUCCESS,
  FETCH_DISTRICT_EXTERNALLAYERS_FAILURE,
  FETCH_DISTRICT_STYLES_REQUEST,
  FETCH_DISTRICT_STYLES_SUCCESS,
  FETCH_DISTRICT_STYLES_FAILURE,
  FETCH_DISTRICT_PARCELS_REQUEST,
  FETCH_DISTRICT_PARCELS_SUCCESS,
  FETCH_DISTRICT_PARCELS_FAILURE,
  ADD_STYLE_REQUEST,
  ADD_STYLE_SUCCESS,
  ADD_STYLE_FAILURE,
  ADD_STYLE_FILE_REQUEST,
  ADD_STYLE_FILE_SUCCESS,
  ADD_STYLE_FILE_FAILURE,
  CHANGE_LAYER_STYLE_REQUEST,
  CHANGE_LAYER_STYLE_SUCCESS,
  CHANGE_LAYER_STYLE_FAILURE,
  PUBLISH_LAYER_REQUEST,
  PUBLISH_LAYER_SUCCESS,
  PUBLISH_LAYER_FAILURE,
  ADD_EXTERNAL_LAYER_REQUEST,
  ADD_EXTERNAL_LAYER_SUCCESS,
  ADD_EXTERNAL_LAYER_FAILURE,
  DELETE_EXTERNAL_LAYER_REQUEST,
  DELETE_EXTERNAL_LAYER_SUCCESS,
  DELETE_EXTERNAL_LAYER_FAILURE,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  ADD_ROLE_LAYER_PERMISSIONS_REQUEST,
  ADD_ROLE_LAYER_PERMISSIONS_SUCCESS,
  ADD_ROLE_LAYER_PERMISSIONS_FAILURE,
  DELETE_ROLE_LAYER_PERMISSIONS_REQUEST,
  DELETE_ROLE_LAYER_PERMISSIONS_SUCCESS,
  DELETE_ROLE_LAYER_PERMISSIONS_FAILURE,
  UPDATE_ROLE_LAYER_PERMISSIONS_REQUEST,
  UPDATE_ROLE_LAYER_PERMISSIONS_SUCCESS,
  UPDATE_ROLE_LAYER_PERMISSIONS_FAILURE,
  UPDATE_ROLE_ATTRS_PERMISSIONS_REQUEST,
  UPDATE_ROLE_ATTRS_PERMISSIONS_SUCCESS,
  UPDATE_ROLE_ATTRS_PERMISSIONS_FAILURE,
  ADD_COMOPSITION_REQUEST,
  ADD_COMOPSITION_SUCCESS,
  ADD_COMOPSITION_FAILURE,
  DELETE_COMOPSITION_REQUEST,
  DELETE_COMOPSITION_SUCCESS,
  DELETE_COMOPSITION_FAILURE,
  DELETE_GES_LAYER_REQUEST,
  DELETE_GES_LAYER_SUCCESS,
  DELETE_GES_LAYER_FAILURE,
  CREATE_NEW_LAYER_REQUEST,
  CREATE_NEW_LAYER_SUCCESS,
  CREATE_NEW_LAYER_FAILURE,
  SIDEDESCRIPTION_VIEW,
  SIDEDESCRIPTION_VIEW_PROJECT,
  CHOSEN_PARCEL,
  FETCH_GRAVES_REQUEST,
  FETCH_GRAVES_SUCCESS,
  FETCH_GRAVES_FAILURE,
  FETCH_ZARZAD_REQUEST,
  FETCH_ZARZAD_SUCCESS,
  FETCH_ZARZAD_FAILURE,
  FETCH_GRAVEYARD_REQUEST,
  FETCH_GRAVEYARD_SUCCESS,
  FETCH_GRAVEYARD_FAILURE,
  FETCH_SECTORS_REQUEST,
  FETCH_SECTORS_SUCCESS,
  FETCH_SECTORS_FAILURE,
  ADDRESS_POLYGON,
  DELETE_LAYER_FAILURE,
  DELETE_LAYER_REQUEST,
  DELETE_LAYER_SUCCESS,
  CHOOSE_GRAVE,
  CHOOSE_GRAVEYARD,
  FETCH_ALL_DISTRICTS_REQUEST,
  FETCH_ALL_DISTRICTS_FAILURE,
  FETCH_ALL_DISTRICTS_SUCCESS,
  FETCH_ALL_ESERVICES_REQUEST,
  FETCH_ALL_ESERVICES_FAILURE,
  FETCH_ALL_ESERVICES_SUCCESS,
  FETCH_ALLDISTRICTSERVICES_REQUEST,
  FETCH_ALLDISTRICTSERVICES_SUCCESS,
  FETCH_ALLDISTRICTSERVICES_FAILURE,
  FETCH_CANDLES_REQUEST,
  FETCH_CANDLES_SUCCESS,
  FETCH_CANDLES_FAILURE,
  FETCH_CANDLES_TYPES_REQUEST,
  FETCH_CANDLES_TYPES_SUCCESS,
  FETCH_CANDLES_TYPES_FAILURE,
} from '../constants';
import fetch from '../core/fetch';
import { setCurrentMapComposition, setCurrentMiniMapComposition } from './layers';


/**
 * Fetches district Role list based ont is rid
 * Dispatch types: FETCH_DISTRICT_ROLES_REQUEST, FETCH_DISTRICT_ROLES_SUCCESS, FETCH_DISTRICT_ROLES_FAILURE
 *
 * @export
 * @returns
 */
export function fetDistrictRoles() {
  return function (dispatch, getState) {
    const store = getState();
    if (store.district && store.district.district && store.district.district.prefix) {
      dispatch({type: 'FETCH_DISTRICT_ROLES_REQUEST'});
      const store = getState();
      const rid_splitted = store.district.district.rid.replace('#', '').split(':');
      const cid = rid_splitted[0];
      const cip = rid_splitted[1];
      fetch( `${process.env.API_URL}/compositions/${cid}/${cip}`)
      .then(r => {
        if (r.status === 200) {
          return r.json();
        } else {
          return dispatch({ type: 'FETCH_DISTRICT_ROLES_FAILURE' });
        }
      })
      .then(resp => {
        return dispatch({ type: 'FETCH_DISTRICT_ROLES_SUCCESS', payload: resp.roles });
      })
    } else {
      return dispatch({ type: 'FETCH_DISTRICT_ROLES_FAILURE' });
    }
  }
}

/**
 * Fetches district compositions
 *
 * @export
 * @returns
 */
export function fetDistrictCompositions() {
  return function (dispatch, getState) {
    const store = getState();
    if (store.district && store.district.district && store.district.district.prefix) {
      dispatch({type: 'FETCH_DISTRICT_COMPOSITIONS_REQUEST'});
      const store = getState();
      const rid_splitted = store.district.district.rid.replace('#', '').split(':');
      const cid = rid_splitted[0];
      const cip = rid_splitted[1];
      fetch( `${process.env.API_URL}/compositions/${cid}/${cip}`)
      .then(r => {
        if (r.status === 200) {
          return r.json();
        } else {
          return dispatch({ type: 'FETCH_DISTRICT_COMPOSITIONS_FAILURE' });
        }
      })
      .then(resp => {
        return dispatch({ type: 'FETCH_DISTRICT_COMPOSITIONS_SUCCESS', payload: resp.compositions });
      })
    } else {
      return dispatch({ type: 'FETCH_DISTRICT_COMPOSITIONS_FAILURE' });
    }
  }
}


/**
 * Fetches parcels for current district, if district prefix is null then
 * dispatches error state
 *
 * @export function
 * @returns Promise
 */
export function fetchDistrictParcels() {
  return function(dispatch, getState) {
    const store = getState();
    if (store.district && store.district.district && store.district.district.prefix) {
      dispatch({type: 'FETCH_DISTRICT_PARCELS_REQUEST'});
      const prefix = store.district.district.prefix;
      fetch( `${process.env.API_URL}/district/${prefix}/parcels`)
      .then(r => {
        if (r.status === 200) {
          return r.json();
        } else {
          return dispatch({ type: 'FETCH_DISTRICT_PARCELS_FAILURE' });
        }
      })
      .then(resp => {
        return dispatch({ type: 'FETCH_DISTRICT_PARCELS_SUCCESS', payload: resp.dzialki });
      })
    } else {
      return dispatch({ type: 'FETCH_DISTRICT_PARCELS_FAILURE' });
    }
  }
}

export function getDistrictData(prefix) {
  return function (dispatch) {
    dispatch({ type: FETCH_DISTRICT_REQUEST });
    const url = process.env.API_URL + '/district/' + prefix + '/';
    return fetch(url, {
      method: 'GET',
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: FETCH_DISTRICT_FAILURE });
        throw { error: 'Wystąpił błąd', status: response.status };
      }
    })
      .then((response) => {
        let defaultMapComomposition = null;
        let defaultMiniMapComposition = null;
        for (const c of response.compositions) { //Find default mini map composition
          if (c.isDefault && c.typ === 'Minimapa') {
            defaultMiniMapComposition = c;
          }
          if (c.isDefault && c.typ === 'Mapa') {
            defaultMapComomposition = c;
          }
        }
        if (!defaultMapComomposition) { // If we dont have default map composition
          for (const c of response.compositions) {
            if (c.typ === 'Mapa') { // then set get first "Mapa" composition and set it as default
              defaultMapComomposition = c;
            }
          }
        }
        if (!defaultMiniMapComposition) { // If we dont have default minimap composition
          for (const c of response.compositions) {
            if (c.typ === 'Minimapa') { // then set get first "Minimapa" composition and set it as default
              defaultMapComomposition = c;
            }
          }
        }

        if (defaultMapComomposition) {
          dispatch(setCurrentMapComposition(defaultMapComomposition));
        }
        if (defaultMiniMapComposition) {
          dispatch(setCurrentMiniMapComposition(defaultMiniMapComposition));
        }

        dispatch({ type: FETCH_DISTRICT_SUCCESS, payload: response });
        return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
}

export function fetchAllDistricts(getState) {
  return function (dispatch, getState) {
    const store = getState();

    if(!store.district.isAllDistrictFetched) {
      dispatch({ type: FETCH_ALL_DISTRICTS_REQUEST });
      return fetch(process.env.API_URL + '/app_district', {
        method: 'GET',
      })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          dispatch({ type: FETCH_ALL_DISTRICTS_FAILURE });
          throw { error: 'Wystąpił błąd', status: response.status };
        }
      })
      .then((response) => {
        dispatch({ type: FETCH_ALL_DISTRICTS_SUCCESS, payload: response });
        return response;
      })
      .catch(error => {
        console.info(error);
      });
    }
  };
}

export function fetchAllServices() {
  return function (dispatch, getState) {
    const store = getState();

    if(!store.district.isServicesFetched) {
      dispatch({ type: FETCH_ALL_ESERVICES_REQUEST });
      return fetch(process.env.API_URL + '/available_services/1', {
        method: 'GET',
      })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          dispatch({ type: FETCH_ALL_ESERVICES_FAILURE });
          throw { error: 'Wystąpił błąd', status: response.status };
        }
      })
      .then((response) => {
        dispatch({ type: FETCH_ALL_ESERVICES_SUCCESS, payload: response });
        return response;
      })
      .catch(error => {
        console.info(error);
      });
    }
  };
}

export function fetchPgLayerData(prefix, layer) {
  return function (dispatch) {
    dispatch({ type: FETCH_PG_LAYER_DATA_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/pg/layers/meta?layerName=' + layer, {
      method: 'GET',
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: FETCH_PG_LAYER_DATA_FAILURE });
        throw { error: 'Wystąpił błąd', status: response.status };
      }
    })
    .then((response) => {
      dispatch({ type: FETCH_PG_LAYER_DATA_SUCCESS, payload: response });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
}
// DELETE_GES_LAYER_REQUEST
// DELETE_GES_LAYER_SUCCESS
// DELETE_GES_LAYER_FAILURE

export function deleteGSLayer(prefix, layerName) {
  return function (dispatch) {
    dispatch({ type: DELETE_GES_LAYER_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/gs/layers/delete?layerName=' + layerName, {
      method: 'DELETE',
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: DELETE_GES_LAYER_FAILURE });
        throw { error: 'Wystąpił błąd', status: response.status };
      }
    })
    .then((response) => {
      dispatch({ type: DELETE_GES_LAYER_SUCCESS, payload: response });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
}

export function fetchDistrictServices() {
  return function (dispatch) {
    dispatch({ type: FETCH_ALLDISTRICTSERVICES_REQUEST });
    return fetch(`${process.env.API_URL}/districts/district_services/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, */*'
      },
    }
    )
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      dispatch({ type: FETCH_ALLDISTRICTSERVICES_FAILURE });
      throw { error: 'Wystąpił błąd', status: response.status };
    })
    .then((response) => {
      dispatch({ type: FETCH_ALLDISTRICTSERVICES_SUCCESS, payload: response });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
}

export function fetchPgLayersList(prefix) {
  return function (dispatch) {
    dispatch({ type: FETCH_PGLAYERLIST_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/pg/layers/', {
      method: 'GET',
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      dispatch({ type: FETCH_PGLAYERLIST_FAILURE });
      throw { error: 'Wystąpił błąd', status: response.status };
    })
    .then((response) => {
      dispatch({ type: FETCH_PGLAYERLIST_SUCCESS, payload: response });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
}

export function deleteStyle(prefix, styleName) {
  return function (dispatch) {
    dispatch({ type: DELETE_STYLE_REQUEST });
    return fetch(process.env.API_URL + '/' + prefix + '/style/delete?nazwa=' + styleName, {
      method: 'DELETE',
    })
    .then((response) => {
      if (response.status === 200) {
        getDistrictData(prefix);
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: DELETE_STYLE_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: DELETE_STYLE_FAILURE });
    });
  };
}

export function addSimpleStyle(prefix, data){
  return dispatch => {
    dispatch({ type: ADD_STYLE_REQUEST });
    return fetch(process.env.API_URL + '/' + prefix + '/style/add/simple', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then(response => {
      dispatch({ type: ADD_STYLE_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: ADD_STYLE_FAILURE });
    })
  }
}

export function createNewLayer(prefix, data){
  return dispatch => {
    dispatch({ type: CREATE_NEW_LAYER_REQUEST });
    //process.env.API_URL
    return fetch(`${process.env.API_URL}/district/${prefix}/create_new_layer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: CREATE_NEW_LAYER_SUCCESS, payload: response.pg_layers });
    })
    .catch((error) => {
      dispatch({ type: CREATE_NEW_LAYER_FAILURE });
    })
  }
}

export function addStyleFromFile(prefix, file, nazwa) {
  return dispatch => {
    dispatch({ type: ADD_STYLE_FILE_REQUEST });
    let formData = new FormData();
    formData.append('file', file, file.name);
    return fetch(process.env.API_URL + '/' + prefix + '/style/add?nazwa=' + nazwa, {
      method: 'POST',
      body: formData,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: ADD_STYLE_FILE_SUCCESS, payload: response });
    })
    .catch((error) => {
      console.info(error)
      dispatch({ type: ADD_STYLE_FILE_FAILURE });
    });
  };
}

export function changeLayerStyle(prefix, layer, newStyle) {
  return dispatch => {
    dispatch({ type: CHANGE_LAYER_STYLE_REQUEST });
    return fetch(process.env.API_URL + '/' + prefix + '/style/set?layer=' + layer + '&newStyle=' + newStyle, {
      method: 'POST',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: CHANGE_LAYER_STYLE_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: CHANGE_LAYER_STYLE_FAILURE });
      throw error;
    });
  };
};

export function publishLayer(prefix, pg_layer) {
  return dispatch => {
    //const hash = new Buffer(`${gregorowicz.k@gmail.com}:${cat}`).toString('base64');
    const username = 'admin';
    const passwd = 'geoserver';
    //const hash = new Buffer('admin:geoserver').toString('base64');
    const hash = new Buffer(`${username}:${passwd}`).toString('base64')
    dispatch({ type: PUBLISH_LAYER_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/gs/layers/add?layerName=' + pg_layer, {
      method: 'POST',
      // headers: {
      //   'Authorization': `Basic ${hash}`,
      // },
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: PUBLISH_LAYER_SUCCESS });
      return response;
    })
    .catch((error) => {
      dispatch({ type: PUBLISH_LAYER_FAILURE });
      console.info(error)
      throw error;
    });
  };
}

export function deleteLayer(prefix, pgLayer) {
  return dispatch => {
    //const hash = new Buffer(`${gregorowicz.k@gmail.com}:${cat}`).toString('base64');
    const username = 'admin';
    const passwd = 'geoserver';
    //const hash = new Buffer('admin:geoserver').toString('base64');
    const hash = new Buffer(`${username}:${passwd}`).toString('base64')
    dispatch({ type: DELETE_LAYER_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/pg/layers/delete?layerName=' + pgLayer, {
      method: 'DELETE',
      // headers: {
      //   'Authorization': `Basic ${hash}`,
      // },
    })
    .then((response) => {
      if (response.status === 200) {
        return response.text();
      }
      throw response;
    })
    .then((response) => {
      dispatch({ type: DELETE_LAYER_SUCCESS, payload: pgLayer });
      return response;
    })
    .catch((error) => {
      dispatch({ type: DELETE_LAYER_FAILURE });
      throw error;
    });
  };
}

export function addExternalLayer(prefix, nazwa, adres, typ, warstwa, wersja) {
  return dispatch => {
    const data = { nazwa, adres, typ, warstwa, wersja };
    dispatch({ type: ADD_EXTERNAL_LAYER_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/externallayers/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: ADD_EXTERNAL_LAYER_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: ADD_EXTERNAL_LAYER_FAILURE });
      throw error;
    });
  };
}

export function deleteExternalLayer(prefix, nazwa) {
  return dispatch => {
    const data = { nazwa };
    dispatch({ type: DELETE_EXTERNAL_LAYER_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/externallayers/', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: DELETE_EXTERNAL_LAYER_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: DELETE_EXTERNAL_LAYER_FAILURE });
      throw error;
    });
  };
}

export function addRole(prefix, nazwa, isDefault) {
  return dispatch => {
    const data = { nazwa, isDefault };
    dispatch({ type: ADD_ROLE_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/role', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: ADD_ROLE_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: ADD_ROLE_FAILURE });
      throw error;
    });
  };
}

export function deleteRole(prefix, nazwa) {
  return dispatch => {
    const data = { nazwa };
    dispatch({ type: DELETE_ROLE_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/role', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: DELETE_ROLE_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: DELETE_ROLE_FAILURE });
      throw error;
    });
  };
}


export function addLayerPermissions(prefix, role, layerName) {
  return dispatch => {
    dispatch({ type: ADD_ROLE_LAYER_PERMISSIONS_REQUEST });
    return fetch(process.env.API_URL + '/' + prefix + '/role/layers/add?role=' + role + '&layerName=' + layerName, {
      method: 'POST',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: ADD_ROLE_LAYER_PERMISSIONS_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: ADD_ROLE_LAYER_PERMISSIONS_FAILURE });
      throw error;
    });
  };
}

export function deleteLayerPermissions(prefix, role, layerName) {
  return dispatch => {
    dispatch({ type: DELETE_ROLE_LAYER_PERMISSIONS_REQUEST });
    return fetch(process.env.API_URL + '/' + prefix + '/role/layers/delete?role=' + role + '&layerName=' + layerName, {
      method: 'DELETE',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: DELETE_ROLE_LAYER_PERMISSIONS_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: DELETE_ROLE_LAYER_PERMISSIONS_FAILURE });
      throw error;
    });
  };
}

export function updateLayerPermissions(prefix, changes, role) {
  return dispatch => {
    const data = JSON.stringify({ permissions: changes, role });
    dispatch({ type: UPDATE_ROLE_LAYER_PERMISSIONS_REQUEST });
    return fetch(process.env.API_URL + '/' + prefix + '/role/layers/update_permissions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: UPDATE_ROLE_LAYER_PERMISSIONS_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: UPDATE_ROLE_LAYER_PERMISSIONS_FAILURE });
      throw error;
    });
  };
}

export function updateAttrsPermissions(prefix, changes, role) {
  return dispatch => {
    const data = JSON.stringify({ permissions: changes, role });
    dispatch({ type: UPDATE_ROLE_ATTRS_PERMISSIONS_REQUEST });
    return fetch(process.env.API_URL + '/' + prefix + '/role/layers/attrs/update_permissions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: UPDATE_ROLE_ATTRS_PERMISSIONS_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: UPDATE_ROLE_ATTRS_PERMISSIONS_FAILURE });
      throw error;
    });
  };
}

export function addComposition(prefix, composition) {
  return dispatch => {
    const data = JSON.stringify(composition);
    dispatch({ type: ADD_COMOPSITION_REQUEST });
    return fetch(process.env.API_URL + '/' + prefix + '/composition', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: ADD_COMOPSITION_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: ADD_COMOPSITION_FAILURE });
      throw error;
    });
  };
}

export function deleteComposition(prefix, name) {
  return dispatch => {
    dispatch({ type: DELETE_COMOPSITION_REQUEST });
    return fetch(process.env.API_URL + '/' + prefix + '/composition?nazwa=' + name, {
      method: 'DELETE',
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.json();
    })
    .then((response) => {
      dispatch({ type: DELETE_COMOPSITION_SUCCESS, payload: response });
      return response;
    })
    .catch((error) => {
      dispatch({ type: DELETE_COMOPSITION_FAILURE });
      throw error;
    });
  };
}
export function sideDescriptionView(view, data, contentType) {
  return dispatch => dispatch({ type: SIDEDESCRIPTION_VIEW, payload: { data, view, contentType } });
}
export function letsDrawSomeProject(invest) {
  return dispatch => dispatch({ type: SIDEDESCRIPTION_VIEW_PROJECT, payload: { invest } });
}
export function choseParcel(data) {
  return dispatch => dispatch({ type: CHOSEN_PARCEL, payload: { data } });
}

export function chooseGrave(grob) {
  return dispatch => dispatch({ type: CHOOSE_GRAVE, payload: grob });
}

export function chooseGraveyard(grob) {
  return dispatch => dispatch({ type: CHOOSE_GRAVEYARD, payload: grob });
}

// funkcja pobiera cmentarze
export function fetchGraves(prefix) {
  return function (dispatch) {
    dispatch({ type: FETCH_GRAVES_REQUEST });
    return fetch(process.env.API_URL + '/cmentarze/' + prefix + '/cmentarze_groby', {
      method: 'GET',
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: FETCH_GRAVES_FAILURE });
        throw { error: 'Wystąpił błąd', status: response.status };
      }
    })
    .then((response) => {
      dispatch({ type: FETCH_GRAVES_SUCCESS, payload: response });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
}

export function fetchZarzad(prefix) {
  return function (dispatch) {
    dispatch({ type: FETCH_ZARZAD_REQUEST });
    return fetch(process.env.API_URL + '/cmentarze/' + prefix + '/zarzad', {
      method: 'GET',
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: FETCH_ZARZAD_FAILURE });
        throw { error: 'Wystąpił błąd', status: response.status };
      }
    })
    .then((response) => {
      dispatch({ type: FETCH_ZARZAD_SUCCESS, payload: response.zarzad });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
}

export function fetchGraveyard(prefix) {
  return function (dispatch) {
    dispatch({ type: FETCH_GRAVEYARD_REQUEST });
    return fetch(process.env.API_URL + '/cmentarze/' + prefix + '/cmentarze', {
      method: 'GET',
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: FETCH_GRAVEYARD_FAILURE });
        throw { error: 'Wystąpił błąd', status: response.status };
      }
    })
    .then((response) => {
      dispatch({ type: FETCH_GRAVEYARD_SUCCESS, payload: response });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
}

export function fetchSectors(prefix) {
  return function (dispatch) {
    dispatch({ type: FETCH_SECTORS_REQUEST });
    return fetch(process.env.API_URL + '/cmentarze/' + prefix + '/cmentarze_sektory', {
      method: 'GET',
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: FETCH_SECTORS_FAILURE });
        throw { error: 'Wystąpił błąd', status: response.status };
      }
    })
    .then((response) => {
      response.features.map((v, i) => {
        v.geometry.coordinates.map((b, j) => {
          b.map((n, k) => {
            let temp = n[0];
            n[0] = n[1];
            n[1] = temp;
          })
        })
      })

      dispatch({ type: FETCH_SECTORS_SUCCESS, payload: response });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
}

export function changeAddressPolygon(data) {
  return dispatch => dispatch({ type: ADDRESS_POLYGON, payload: { data } });
}

export function fetchCandles(prefix, graveId) {
  return function (dispatch) {
    dispatch({ type: FETCH_CANDLES_REQUEST });
    return fetch(`${process.env.API_URL}/cmentarze/${prefix}/znicze/${graveId}`, {
      type: 'GET',
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: FETCH_CANDLES_FAILURE });
        throw { error: 'Wystąpił błąd', status: response.status };
      }
    })
    .then((response) => {
      dispatch({ type: FETCH_CANDLES_SUCCESS, payload: response });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
};

export function fetchCandlesTypes(prefix) {
  return function (dispatch) {
    dispatch({ type: FETCH_CANDLES_TYPES_REQUEST });
    return fetch(`${process.env.API_URL}/cmentarze/${prefix}/znicze`, {
      type: 'GET',
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: FETCH_CANDLES_TYPES_FAILURE });
        throw { error: 'Wystąpił błąd', status: response.status };
      }
    })
    .then((response) => {
      dispatch({ type: FETCH_CANDLES_TYPES_SUCCESS, payload: response });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
};


// WEBPACK FOOTER //
// src/actions/district.js